import { Panels } from "@msuite/ui/panels";
import { OrganizationSettingsAbsenceGeneral } from "./organization-settings-absence-general";
import { OrganizationSettingsAbsenceTypes } from "./organization-settings-absence-types";

export function OrganizationSettingsAbsences() {
	return (
		<Panels>
			<Panels.Panel>
				<OrganizationSettingsAbsenceGeneral />
			</Panels.Panel>
			<Panels.Panel flex={2}>
				<OrganizationSettingsAbsenceTypes />
			</Panels.Panel>
		</Panels>
	);
}
